import React from "react";
import Footer from "../footer/Footer";
import VTVenueInvoiceDetails from "../page/VTVenueInvoiceDetails";
import Header from "../header/Header";

/**
 * Invoice Details
 *
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingVenueInvoiceDetails({page}) {
    return (
        <>
            <Header headerType="AdminOnly"/>
            <VTVenueInvoiceDetails/>
            <Footer/>
        </>
    );
}